import React from "react";
import { FlameIcon } from "lucide-react";
import { useOfferClock } from "../hooks/useOfferClock";
export function ScarcityBar() {
  const {
    spots,
    totalSpots
  } = useOfferClock();
  const pct = (totalSpots - spots) / totalSpots * 100;
  return <div className="rounded-2xl border-2 border-alert/25 bg-[#FFF3F3] p-4" data-id="element-79" data-mp="2l4o3n8sz25h4">
      <p className="flex items-center gap-2 text-[15px] font-bold leading-snug text-alert" data-id="element-80" data-mp="2q2ptqdotf523">
        <FlameIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-81" data-mp="2b5yt613ennaw" />
        Only {spots} spots left at the promotional price!
      </p>
      <div className="mt-3 h-5 w-full overflow-hidden rounded-full bg-white ring-1 ring-alert/20" role="progressbar" aria-valuenow={Math.round(pct)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-82" data-mp="2g3qnf1rivli9">
        <div className="bar-stripes h-full rounded-full bg-alert transition-[width] duration-300 ease-out" style={{
        width: `${pct}%`
      }} data-id="element-83" data-mp="fgrob9frw5b" />
      </div>
      <p className="mt-2 text-xs font-semibold text-muted" data-id="element-84" data-mp="33md24yty9om7">{Math.round(pct)}% of promotional spots already claimed</p>
    </div>;
}